import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, createElement, useMemo, useEffect, useRef, useState, } from 'react';
import Slider from 'react-slick';
import { propBool, propChildren, propFunc, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import NextArrow from './NextArrow';
import PrevArrow from './PrevArrow';
const CustomSlider = (props) => {
    const { children, className, config, customNextArrow, customPrevArrow, dataAttributes, fillCount, leftArrowDisabled, leftArrowStyle, prevMinShowSlide, rightArrowDisabled, rightArrowStyle, setSliderRef, wrapperClassName, wrapperElement, } = props;
    const fillArray = useMemo(() => Object.keys(Array(fillCount || 0).fill('')), [fillCount]);
    const sliderRef = useRef();
    const [hasSetPosition, setHasSetPosition] = useState(false);
    // https://github.com/akiran/react-slick/issues/1946#issuecomment-768935762
    useEffect(() => {
        if (sliderRef.current && config.initialSlide && !hasSetPosition) {
            sliderRef.current.slickGoTo(config.initialSlide);
            setHasSetPosition(true);
        }
    }, [config.initialSlide, hasSetPosition, sliderRef]);
    const Wrapper = wrapperElement || Fragment;
    const setProps = {};
    if (wrapperElement) {
        setProps.className = wrapperClassName;
    }
    const rightProps = {
        customStyle: rightArrowStyle,
        disabled: rightArrowDisabled,
    };
    const leftProps = {
        customStyle: leftArrowStyle,
        disabled: leftArrowDisabled,
        minShowSlide: prevMinShowSlide,
    };
    return (_jsx(Wrapper, Object.assign({}, setProps, { children: _jsxs(Slider, Object.assign({}, config, { className: className, nextArrow: customNextArrow ? (createElement(customNextArrow, rightProps)) : (_jsx(NextArrow, { customStyle: rightArrowStyle, dataAttributes: dataAttributes, disabled: rightArrowDisabled })), prevArrow: customPrevArrow ? (createElement(customPrevArrow, leftProps)) : (_jsx(PrevArrow, { customStyle: leftArrowStyle, dataAttributes: dataAttributes, disabled: leftArrowDisabled, minShowSlide: prevMinShowSlide })), ref: (slide) => {
                sliderRef.current = slide;
                if (setSliderRef) {
                    setSliderRef(slide);
                }
            } }, { children: [children, fillArray.map((v) => (_jsx("div", { className: 'is-dnone' }, v)))] })) })));
};
CustomSlider.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    config: propShape().isRequired,
    customNextArrow: propChildren(),
    customPrevArrow: propChildren(),
    dataAttributes: propShape(),
    fillCount: propNumber(),
    leftArrowDisabled: propBool(),
    leftArrowStyle: propShape(),
    prevMinShowSlide: propNumber(),
    rightArrowDisabled: propBool(),
    rightArrowStyle: propShape(),
    setSliderRef: propFunc(),
    wrapperClassName: propStr(),
    wrapperElement: propStr(),
};
CustomSlider.defaultProps = {
    className: '',
    customNextArrow: undefined,
    customPrevArrow: undefined,
    dataAttributes: {},
    fillCount: undefined,
    leftArrowDisabled: false,
    leftArrowStyle: {},
    prevMinShowSlide: undefined,
    rightArrowDisabled: false,
    rightArrowStyle: {},
    setSliderRef: null,
    wrapperClassName: '',
    wrapperElement: null,
};
export default CustomSlider;
